import { render, staticRenderFns } from "./picknotassignedShipments.vue?vue&type=template&id=e28323a4"
import script from "./picknotassignedShipments.vue?vue&type=script&lang=js"
export * from "./picknotassignedShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports